import axios from 'axios'
import { CommonFilterModel, CommonParams } from '@/api/resources/common/shared/models/common.models'
import {
    ConfigurationPriorityCreateRequest,
    ConfigurationPriorityPatchInBatchRequest,
    ConfigurationPriorityResponse
} from '@/modules/configurationModule/detail/automation/grossing-shelf/immediate-shelf-priority/services/configuration-priority/configuration-priority.dto'
import { IResponseAgGrid } from '@/shared/models/ag-grid.model'
import { EntityIdentifiersRequest, EntityIdentifierWithErrorResponse } from '@/shared/models/http/http.model'

class ConfigurationPriorityService {
    async create(request: ConfigurationPriorityCreateRequest): Promise<ConfigurationPriorityResponse> {
        const response = await axios.post<ConfigurationPriorityResponse>(`/configuration/priorities`, request)
        return response.data
    }

    async paginator(filterModel?: CommonFilterModel, params?: CommonParams): Promise<IResponseAgGrid<ConfigurationPriorityResponse>> {
        const response = await axios.put<IResponseAgGrid<ConfigurationPriorityResponse>>(`/configuration/priorities`, { ...filterModel }, { params })
        return response.data
    }

    async get(priorityId: number): Promise<ConfigurationPriorityResponse> {
        const response = await axios.get<ConfigurationPriorityResponse>(`/configuration/priorities/${priorityId}`)
        return response.data
    }

    async delete(request: EntityIdentifiersRequest): Promise<EntityIdentifierWithErrorResponse[]> {
        const response = await axios.delete<EntityIdentifierWithErrorResponse[]>(`/configuration/priorities/batch`, { data: request })
        return response.data
    }

    async patch(request: ConfigurationPriorityPatchInBatchRequest[]): Promise<EntityIdentifierWithErrorResponse[]> {
        const response = await axios.patch<EntityIdentifierWithErrorResponse[]>(`/configuration/priorities/batch`, request)
        return response.data
    }

    async search(query: string, params?: CommonParams): Promise<IResponseAgGrid<ConfigurationPriorityResponse>> {
        const response = await axios.get<IResponseAgGrid<ConfigurationPriorityResponse>>(`/configuration/priorities/search`, { params: { ...params, query } })
        return response.data
    }
}

export const configurationPriorityService = new ConfigurationPriorityService()
